import styled from "styled-components";

import { ReportFields } from "../../../config/types";
import { spectrum } from "../../../utils/theme";

const Container = styled.div`
  border: 0.5px solid ${spectrum.gray20};
  border-radius: 8px;
  overflow: auto;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  margin-bottom: 12px;
  max-height: 350px;
`;

const Field = styled.div<{ $required?: boolean }>`
  color: ${spectrum.slate90};
  font-family: "SF Mono", SFMono-Regular, ui-monospace, "DejaVu Sans Mono", Menlo, Consolas,
    monospace;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  display: inline-block;
  word-wrap: break-word;
  max-width: ${({ $required }) => ($required ? "80%" : "100%")};
`;

const Body = styled.div`
  display: flex;
  padding: 10px 12px;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  overflow: auto;
`;

const RequiredField = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

const Required = styled.p`
  color: ${spectrum.red50};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  padding: 0;
  margin: 0;
`;

interface IntegrationReportFieldsTableProps {
  reportFields: ReportFields;
}

const IntegrationReportFieldsTable = ({
  reportFields,
}: IntegrationReportFieldsTableProps) => {
  return (
    <>
      <Container>
        <Body>
          {/* required fields */}
          {reportFields.required_fields.map((field) => (
            <RequiredField key={field}>
              <Field className="font-mono" $required>
                {field}
              </Field>
              <Required>Required</Required>
            </RequiredField>
          ))}
          {/* other supported fields */}
          {reportFields.supported_fields.map((field) => (
            <Field className="font-mono" key={field}>
              {field}
            </Field>
          ))}
        </Body>
      </Container>
    </>
  );
};

export default IntegrationReportFieldsTable;
